module.exports = __webpack_public_path__ + "static/media/progress-circle-threequarter~bhhGLGpS.3ec37af8.svg";